import React from 'react';

import { useTranslation } from 'react-i18next';
import { Flex } from 'components';
import { S } from 'design-system-web';
import { HookFormToggle } from 'components/reactHookForm';
import { useFormContext } from 'react-hook-form';
import { WorkOrderModuleConfiguration } from 'lane-shared/domains/workOrder/types/workOrder';

import styles from '../Configuration.module.scss';
import cx from 'classnames';

export function MessageNotification() {
  const { t } = useTranslation();
  const { control } = useFormContext<WorkOrderModuleConfiguration>();

  return (
    <div>
      <div className="py-1">
        <h2 className="text-lg font-medium text-gray-900">
          {t(
            'web.admin.work-order.configuration.message.notification.tab.title'
          )}
        </h2>
      </div>

      <div className={cx(styles.border, 'py-2 px-2 mt-2 space-y-2')}>
        <div className="space-y-3">
          <Flex align="flex-start">
            <div>
              <HookFormToggle
                control={control}
                name="messageNotification.tenantChat"
                testId="tenant-chat-toggle"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-900 mb-1">
                {t(
                  'web.admin.work-order.configuration.message.notification.rule.tenantChatNotification'
                )}
              </h3>
              <S variant="secondary" interfaceStyle="light">
                {t(
                  'web.admin.work-order.configuration.message.notification.rule.tenantChatNotification.description'
                )}
              </S>
            </div>
          </Flex>
        </div>
      </div>
    </div>
  );
}
